import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectDataConfigurationsList,
  selectDataConfigurationsLoading,
} from '../../redux/data/selectors';
import { actions as getConfigurationsActions } from '../../redux/data/configurations';
import createPayloadForFeatureToggle from '../../utils/createPayloadForFeatureToggle';

export function useFeatureToggleConfig({ feature, options }) {
  const dispatch = useDispatch();

  const getFeatureConfig = useCallback(() => {
    dispatch(
      getConfigurationsActions.send(
        createPayloadForFeatureToggle([
          {
            action: feature,
            options: { ...options },
          },
        ]),
      ),
    );
  }, [feature, options]);

  const clearFeatureConfig = useCallback(() => {
    dispatch(getConfigurationsActions.clear());
  }, []);

  const featureToggleConfigList = useSelector(selectDataConfigurationsList);
  const featureToggleLoading = useSelector(selectDataConfigurationsLoading);

  const isFeatureToggleOn = useMemo(() => {
    const featureToggle =
      featureToggleConfigList.find(entity => !!entity[feature]) || {};
    return featureToggle[feature];
  }, [featureToggleConfigList, feature]);

  return {
    getFeatureConfig,
    isFeatureToggleOn,
    clearFeatureConfig,
    featureToggleLoading,
  };
}



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/useFeatureToggleConfig.js